import { useContext } from 'react';
import { FetchStatusContext } from 'src/utils/context';

export const useFetchStatusContext = () => {
  const context = useContext(FetchStatusContext);
  if (!context) {
    throw new Error('useFetchStatusContext must be used within a FetchStatusProvider');
  }
  return context;
};
